import { useContext, useEffect, useState } from "react";
import { useFilters } from "shared-components/Components/Filters/Filters.hook";
import InputFilterBox from "../InputFilterBox/web"
import { DataOptionsTypes } from "../types";
import { currenciesByCountry, operation_type_id } from "../options";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";
import { useSearchResultsFilters } from "../../Filters/SearchResultsFilters.hook";
import { getOperationValue, getOptionsSelectedText } from "src/utils/Functions";

export const OperationTypeFilter = ({show}) => {
    if (!show) return null;
    
    const { filters, filtersTags } = useFilters();
    const { changeFiltersAndUpdateURL: changeFilters } = useSearchResultsFilters();
    const { country_code } = useContext(ConfigStateContext);
    const [operationTypeText, setOperationTypeText] = useState('Tipo de oferta');
    const operationTypeIdByCountry = operation_type_id.filter(type => type.countries.includes(country_code ? country_code.toUpperCase() : ""));
    const operationTypeList = operationTypeIdByCountry.map((type) => ({ text: type.text, value: type.value, projects: type.projects }));
    const currenciesList = currenciesByCountry[country_code] ?? [];

    useEffect(() => {
        if (filters.operation_type_id) {
            const text = getOptionsSelectedText(operationTypeIdByCountry, filters?.operation_type_id, filters?.projects)

            setOperationTypeText(text)
        } else {
            setOperationTypeText('Tipo de oferta')
        }
    }, [filters?.operation_type_id, filters?.projects]);

    const handleOnChange = (option: DataOptionsTypes) => {
        const value = getOperationValue(option);

        const valuesToChange = {
            operation_type_id: {text: option.text, value: value},
            projects: {text: null, value: option.projects},
            property_type_id: option.projects ? [] : filtersTags?.property_type_id ?? [],
            minPrice: undefined,
            maxPrice: undefined,
        }

        /**
         * Tengo que verificar si la moneda que se esta filtrando, se puede usar en la nueva operación
         * De lo contrario, fuerzo una nueva moneda
         */
        const prefferedCurrency = currenciesList.find(currency => currency.operationTypes.includes(value));

        if (prefferedCurrency.value !== filters?.currencyID) {
            valuesToChange["currencyID"] = prefferedCurrency.value;
        } else if (country_code !== 'CO' && option.value === 1) {
            valuesToChange["currencyID"] = 1;
        }

        changeFilters(valuesToChange)
    }

    const isSelected = (option) => {
        const value = getOperationValue(option);

        return value === filters?.operation_type_id && option.projects === !!filters?.projects
    }

    return (
        <InputFilterBox
            active={true}
            label={operationTypeText}
            scrollable
        >
            <div className="optionList">
                {operationTypeList
                    .map((val, i) => (
                        <div key={val.text + "-" + i} className="optionList__option">
                            <input
                                type="radio"
                                className="radioCustomInput"
                                onChange={() => handleOnChange(val)}
                                name={"operation_type_id"}
                                id={val.text}
                                value={val.value}
                                checked={isSelected(val)}
                            />
                            <label htmlFor={val.text}>{val.text}</label>
                        </div>
                    ))
                }
            </div>
        </InputFilterBox>
    )
}
